import { useState, useEffect } from "react";

import { Form } from "react-bootstrap";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Card,
  CardBody,
  Button,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Input
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import ApplicatedQuestionList from "../../../../components/ApplicatedQuestionList/ApplicatedQuestionList";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";

const EvaluationADRSchedule = props => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewModal, setViewModal] = useState(false);
  const [viewedActivity, setViewedActivity] = useState(null);
  const [viewPDFModal, setViewPDFModal] = useState(false);
  const [selectedAllocationId, setSelectedAllocationId] = useState(null);
  const [scheduleModal, setScheduleModal] = useState(false);

  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");

  const [seriesList, setSeriesList] = useState([]);
  const [seriesFilter, setSeriesFilter] = useState(null);

  const [disciplineList, setDisciplineList] = useState([]);
  const [disciplineFilter, setDisciplineFilter] = useState([]);

  const rowData = list.find(
    item => item.allocation_id === selectedAllocationId
  );

  const isAlagoasGroup = props.user?.user_roles?.find(
    elem => elem.group_name === "Escola 10 Digital"
  );

  useEffect(() => {
    setLoading(true);
    pullAllocations();
  }, [disciplineFilter, seriesFilter]);

  const handleError = response => {
    if (response === "Unauthorized") {
      props.logout(props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  };

  useEffect(() => {
    props.setObj(16, props.currentRoute, props.currentRoute);

    (async () => {
      try {
        await axios
          .get(`${URL.api}classification/discipline/list`, {
            headers: { authorization: `Bearer ${props.user.token}` }
          })
          .then(disciplineResponse => {
            setDisciplineList(disciplineResponse.data.data);
          });
        await axios
          .get(`${URL.api}classification/serie/list`, {
            headers: { authorization: `Bearer ${props.user.token}` }
          })
          .then(seriesResponse => {
            setSeriesList(seriesResponse.data.data);
          });

        pullAllocations();
      } catch (error) {
        handleError(error.response.data.error);
      }
    })();
  }, []);

  const pullAllocations = async () => {
    const currYear = new Date().getFullYear();

    const allocationsResponse = await axios.get(`${URL.api}adr/allocate/list`, {
      params: {
        serie_id: seriesFilter,
        discipline_id: disciplineFilter,
        // status_id: 2,
        start: `${currYear}-01-01`,
        end: `${currYear}-12-31`
      },
      headers: { Authorization: `Bearer ${props.user.token}` }
    });

    const newList = allocationsResponse.data.data.map(room => ({
      ...room,
      startDisplay: formatDate(room.start),
      endDisplay: formatDate(room.end)
    }));

    setList(newList);
    setLoading(false);
  };

  const formatDate = date => {
    if (!date) return "Não agendada";

    const newDate = new Date(date);
    return `${newDate.getDate()}/${newDate.getMonth() + 1}/${newDate
      .getFullYear()
      .toString()
      .substring(2)} às ${
      newDate.getHours() < 10 ? "0" : ""
    }${newDate.getHours()}:${
      newDate.getMinutes() < 10 ? "0" : ""
    }${newDate.getMinutes()}`;
  };

  const allocateAction = row => {
    // props.history.push(`/evaluation/adr/allocate/${row.id}`);

    setScheduleModal(true);
    setSelectedAllocationId(row.allocation_id);
  };

  const scheduleEvaluation = async allocation => {
    if (!start || !end) {
      toastr.error("Erro", "Preencha os campos de data e hora");
      return;
    }

    if (new Date(start).valueOf() < Date.now() + 30 * 60 * 1000) {
      toastr.error(
        "Erro",
        "A avaliação deve ser agendada com 30 minutos de antecedência"
      );
      return;
    }

    if (new Date(start).valueOf() > new Date(end).valueOf()) {
      toastr.error("Erro", "A data de início deve ser anterior ao fim");
      return;
    }

    const allocateObj = {
      activity_id: allocation.id,
      room_list: [
        {
          allocation_id: allocation.allocation_id,
          start_allocation: start,
          end_allocation: end,
          release: false,
          room_id: allocation.room_id,
          users: []
        }
      ]
    };

    try {
      await axios.post(`${URL.api}activity/allocate/insert`, allocateObj, {
        headers: { Authorization: `Bearer ${props.user.token}` }
      });

      toastr.success(
        "Agendada com sucesso!",
        "A avaliação foi agendada na turma"
      );

      setScheduleModal(false);
      setStart("");
      setEnd("");
      setLoading(true);
      pullAllocations();
    } catch (error) {
      handleError("Não foi possível agendar a avaliação");
    }
  };

  const viewAction = async row => {
    axios
      .get(`${URL.api}activity/activity/singleView/${row.id}`, {
        headers: { authorization: `Bearer ${props.user.token}` }
      })
      .then(activityResponse => {
        setViewModal(true);
        setSelectedAllocationId(row.allocation_id);
        setViewedActivity(activityResponse.data.data);
      });
  };

  // const rowbackAction = row => {
  //   const obj = {
  //     id: row.id,
  //     status_id: 1
  //   };

  //   axios.post(`${URL.api}activity/activity/update`, obj, {
  //     headers: { authorization: `Bearer ${props.user.token}` }
  //   });
  // };

  const printAction = row => {
    setSelectedAllocationId(row.allocation_id);
    setViewPDFModal(true);
  };

  return (
    <>
      <Modal isOpen={viewPDFModal} size="md">
        <ModalHeader toggle={() => setViewPDFModal(!viewPDFModal)}>
          PDF da prova
        </ModalHeader>
        <ModalBody>
          {rowData?.file && (
            <button
              className="d-flex border rounded p-0 w-100"
              type="button"
              onClick={() => window.open(rowData.file.link, "_blank")}
            >
              <div className="bg-warning p-3 h-100 rounded-left">
                <i className="fa fa-file"></i>
              </div>
              <div className="d-flex align-items-center justify-content-start my-3 mx-2">
                {rowData.file.name}
              </div>
            </button>
          )}
        </ModalBody>
      </Modal>

      <Modal isOpen={scheduleModal} size="lg">
        <ModalHeader
          toggle={() => {
            setStart("");
            setEnd("");
            setScheduleModal(!scheduleModal);
          }}
        >
          <h3 className="mb-0">Agendamento</h3>
        </ModalHeader>
        <ModalBody className="py-4">
          <h5>
            <strong>Avaliação: </strong>
            {rowData?.evaluation_name}
          </h5>
          <div className="d-flex mb-3">
            <div className="d-flex-align-items-center mr-2">
              <i className="fa fa-institution mr-1"></i>
              {props.user.user_roles[0].school_name}
            </div>
            <div className="d-flex-align-items-center">
              <i className="fa fa-group mr-1"></i>
              {rowData?.room_name} - {rowData?.serie_name}
            </div>
          </div>
          <div className="d-flex align-items-center justify-content-start">
            <div className="d-flex flex flex-column align-items-start justify-content-center w-50">
              <label className="mb-0">Início:</label>
              <Form.Control
                type="datetime-local"
                name="start"
                value={start ?? ""}
                // defaultValue={}
                onChange={e => {
                  const startDate = new Date(e.target.value);
                  if (startDate.valueOf() < Date.now() + 30 * 60 * 1000) {
                    startDate.setTime(Date.now() + 30 * 60 * 1000);
                  }

                  const endDate = new Date(
                    startDate.valueOf() + 30 * 60 * 1000
                  );

                  // gambiarra para ajustar o horário do brasil em relácão ao UTC. melhorar isso
                  startDate.setHours(startDate.getHours() - 3);
                  endDate.setHours(endDate.getHours() - 3);

                  setStart(startDate.toISOString().substring(0, 16));
                  setEnd(endDate.toISOString().substring(0, 16));
                }}
                style={{ width: "100%" }}
              />
            </div>
            <div className="d-flex flex flex-column align-items-start justify-content-center ml-2 w-50">
              <label className="mb-0">Fim:</label>
              <Form.Control
                type="datetime-local"
                name="end"
                value={end ?? ""}
                onChange={e => setEnd(e.target.value)}
                style={{ width: "100%" }}
              />
            </div>
          </div>

          <small className="text-muted">
            *A avaliação deve ser agendada com 30 minutos de antecedência
          </small>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => scheduleEvaluation(rowData)}>
            Agendar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={viewModal}
        toggle={() => setViewModal(!viewModal)}
        size="xl"
      >
        <ModalHeader toggle={() => setViewModal(!viewModal)}>
          Visualizar
        </ModalHeader>
        <ModalBody>
          {!viewedActivity ? (
            <Loading top="45" left="50" />
          ) : (
            <ApplicatedQuestionList
              activityId={viewedActivity.id}
              currentRoute={props.currentRoute}
              id={viewedActivity.items[0].obj_id}
              history={props.history}
              prototype
              item_id={viewedActivity.item_id}
              result_type={viewedActivity.result_type}
              ended={false}
              end_date={viewedActivity.activity_end}
              viewModal
            />
          )}
        </ModalBody>
      </Modal>
      <div className="animated fadeIn">
        <Row>
          <Breadcrumb current={props.currentRoute} />
          <Card className="w-100">
            <CardBody>
              <Row>
                <Col
                  xs="12"
                  lg="3"
                  className="d-flex flex-column align-items-start justify-content-start"
                >
                  <label>Regional:</label>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-institution"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input title="Regional" type="select" disabled>
                      <option value={props.user.user_roles[0].region_id}>
                        {props.user.user_roles[0].region_name}
                      </option>
                    </Input>
                  </InputGroup>
                </Col>
                <Col
                  xs="12"
                  lg="3"
                  className="d-flex flex-column align-items-start justify-content-start"
                >
                  <label>Escola:</label>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-institution"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input title="Escola" type="select" disabled>
                      <option
                        value={
                          props.user.user_roles[0].school_id ??
                          props.general.active_roles.school_id
                        }
                      >
                        {props.user.user_roles[0].school_name}
                      </option>
                    </Input>
                  </InputGroup>
                </Col>
                <Col
                  xs="12"
                  lg="3"
                  className="d-flex flex-column align-items-start justify-content-start"
                >
                  <label>Série:</label>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-institution"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      title="Série"
                      type="select"
                      value={seriesFilter}
                      onChange={e => setSeriesFilter(e.target.value)}
                    >
                      <option value={0} key="0">
                        Todas
                      </option>
                      {seriesList.map(serie => (
                        <option value={serie.id} key={serie.id}>
                          {serie.name}
                        </option>
                      ))}
                    </Input>
                  </InputGroup>
                </Col>
                <Col
                  xs="12"
                  lg="3"
                  className="d-flex flex-column align-items-start justify-content-start"
                >
                  <label>Disciplina:</label>
                  <InputGroup>
                    <InputGroupAddon addonType="prepend">
                      <InputGroupText>
                        <i className="fa fa-institution"></i>
                      </InputGroupText>
                    </InputGroupAddon>
                    <Input
                      title="Disciplina"
                      type="select"
                      value={disciplineFilter}
                      onChange={e => setDisciplineFilter(e.target.value)}
                    >
                      <option value={0}>Todas</option>
                      {disciplineList.map(discipline => (
                        <option value={discipline.id} key={discipline.id}>
                          {discipline.name}
                        </option>
                      ))}
                    </Input>
                  </InputGroup>
                </Col>
              </Row>
            </CardBody>
          </Card>
          {loading ? (
            <Loading top="45" left="50" />
          ) : (
            <>
              {list ? (
                <div id="list">
                  <DataTable
                    list={list}
                    title="Agendamento de Provas"
                    defaultSortOrder="desc"
                    header={[
                      { name: "id", denomination: "ID" },
                      { name: "evaluation_name", denomination: "Prova" },
                      { name: "discipline_name", denomination: "Disciplina" },
                      {
                        name: "room_name",
                        denomination: "Turma",
                        width: 150
                      },
                      {
                        name: "serie_name",
                        denomination: "Série",
                        width: 108
                      },
                      {
                        name: "startDisplay",
                        denomination: "Início",
                        width: 145
                      },
                      { name: "endDisplay", denomination: "Fim", width: 145 }
                    ]}
                    action
                    // btnRowback
                    // rowbackAction={rowbackAction}
                    // btnView
                    viewAction={viewAction}
                    btnAllocate
                    allocateAction={allocateAction}
                    btnAllocateToolTip="Agendar"
                    btnReport={!isAlagoasGroup}
                    // btnPrint
                    printAction={printAction}
                  />
                </div>
              ) : (
                <Loading />
              )}
            </>
          )}
        </Row>
      </div>
      <ProtectedRoute routeId={props.currentRoute} />
    </>
  );
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EvaluationADRSchedule);
